import React from "react";

const IconSearch = props => (
  <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" fill="#583EF5" {...props}>
    <path fillRule="evenodd" clipRule="evenodd" d="M19.5003 17.7922L14.7544 13.0226C20.4573 3.60452 8.96954 -4.00103 2.32534 2.31935C-4.12356 9.58114 3.95026 20.3117 13.0045 14.7804L17.7504 19.4211C19.1214 20.9289 20.8752 19.1711 19.5003 17.7922ZM8.05553 2.48341C15.5512 2.48341 15.7934 13.7726 8.05553 13.7726C0.520743 13.7726 0.735576 2.48341 8.05553 2.48341Z" />
  </svg>
);

export default IconSearch;
